import { POSITION_SLOT_API_OFFICE_LABELS } from 'domain/shared/employee/office';
import type { PositionFillRequest, PositionFillRequestListItem } from '../types';
import { BusinessFunction } from 'domain/shared/businessFunction';
import { Technology } from 'domain/shared/career';
import { PositionType, OfficeType } from 'domain/shared/employee';
import { VacancyGroupReferencesByVacancyId } from 'domain/shared/newVacancy/useVacancyReferenceService';

type PositionFillRequestEnrichmentContext = {
  positions: Pick<PositionType, 'id' | 'name'>[];
  technologies: Technology[];
  offices: Pick<OfficeType, 'id' | 'name'>[];
  businessFunctions: BusinessFunction[];
  vacancyGroupByVacancyId?: VacancyGroupReferencesByVacancyId;
};

const buildPositionFillRequestDisplayName = (request: PositionFillRequest) =>
  request.positionSlot
    ? [request.positionSlot.specialization, request.positionSlot.technology, request.positionSlot.competencyLevel]
        .filter(Boolean)
        .join(' ')
    : request.positionSlotId;

const enrichPositionFillRequest = (
  request: PositionFillRequest,
  context: PositionFillRequestEnrichmentContext,
): PositionFillRequestListItem => {
  const positionSlot = request.positionSlot;

  const businessFunctionLabel =
    context.businessFunctions.find(businessFunction => businessFunction.id === positionSlot.businessFunctionId)?.name ||
    positionSlot.businessFunctionId;

  return {
    ...request,
    requestDisplayName: buildPositionFillRequestDisplayName(request),
    technologyLabel: positionSlot?.technology ?? null,
    businessFunctionLabel,
    officesLabel: (positionSlot?.offices || [])
      .map(office => POSITION_SLOT_API_OFFICE_LABELS[office] || office)
      .join(', '),
  };
};

export const enrichPositionFillRequests = (
  requests: PositionFillRequest[],
  context: PositionFillRequestEnrichmentContext,
): PositionFillRequestListItem[] => requests.map(pfr => enrichPositionFillRequest(pfr, context));
